import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { Button, Dropdown, Icon, Menu, Tabs, Tooltip } from 'antd';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { IConfigApp } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { appStore } from 'kts-platform-frame/api';
import withRouter from 'src/routes/withRouter';
import { IAppInfo, IuserInfo } from './interface';
import { getVisitedListByUserId } from './storage';
import { IVisitedItem, IRoute } from './interface';
import Sdk from 'kts-platform-frame/appSdk';
const css = require('./index.scss');
/** 全局数据片段数据接口 */
interface IReduxStatePart {
    appConfig?: Map<string, IConfigApp>;
}

let UNLISTEN;
/** 组建的props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    appConfig: state.config.appList.map,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    /** 构造函数 */
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            appkey: Sdk.instance.getAppKey,
            appInfo: Sdk.instance.user['appInfo'],
            visible: false
        };
    }
    componentDidMount() {
        this.modulesState.visitedList = getVisitedListByUserId(Sdk.instance.user.userInfo.cUserId);
        UNLISTEN = this.props.history.listen((route) => {
            this.setVisitedList(route);
        });
        this.setModulesState();
    }
    componentWillUnmount() {
        // this.modulesState.unlisten && this.modulesState.unlisten();
        UNLISTEN && UNLISTEN();
    }
    /**
     * 根据路由添加最近访问记录
     * @param route 
     */
    async setVisitedList(route: any) {
        const appInfo = await this.getAppInfo(Sdk.instance.getAppKey);
        if (route && appInfo) {
            ModulesAction.setVisitedRecord(Sdk.instance.user.userInfo.cUserId, { ...appInfo, pathName: route.pathname + route.search });
        }

        this.modulesState.visitedList = getVisitedListByUserId(Sdk.instance.user.userInfo.cUserId);
    }
    getAppInfo = async (appKey: string) => {
        // 从路由状态获取

        if (this.state.appKey === appKey) {
            return this.state.appInfo;
        }
        if (appKey !== this.state.appKey) {
            // 从服务区获取
            const queryAppInfo = await appStore.queryAppInfo(this, { appKey });
            this.setState({
                appInfo: queryAppInfo.res,
                appKey: Sdk.instance.getAppKey
            });
            return queryAppInfo.res;
        }

    }
    /**
     * 根据最近访问记录跳转页面
     * @param visitedItem 当前用户的最近访问记录
     */
    goByRecentVisited = (visitedItem: IVisitedItem) => {
        // console.log(visitedItem);
        if (Sdk.instance.getAppKey !== visitedItem.appKey) {
            this.props.history.push(visitedItem.pathName);
        }
    }
    /**
     * 获取menuItem 下拉单中的menu
     * @param visitedList 当前用户的最近访问记录List
     * @returns 
     */
    getMenuItem() {
        let result = null;
        const visitedList: IVisitedItem[] = this.modulesState.visitedList;
        // console.log(visitedList);
        if (visitedList && visitedList.length > 0) {
            result = visitedList.map((item: IVisitedItem, index: number) => {
                return <Menu.Item className={css.menuItem} key={index} onClick={() => this.goByRecentVisited(item)} >{item.appName}</Menu.Item>;
            });
        } else {
            result = (<Menu.Item className={css.menuItem} >无</Menu.Item>);
        }
        return result;
    }
    /**
     * 
     * @returns 返回 Menu 组件
     */
    getOverlayData = () => {
        return <Menu >{this.getMenuItem()}</Menu>;
    }
    onChange = visible => {
        this.setState({
            visible
        });
    }
    onHide = () => {
        this.setState({ visible: false });
    }
    render() {
        return (
            <div className={css.modules} >
                {/* {this.appRender_()} */}
                <Tooltip
                    title='最近访问'
                    placement="bottom"
                    overlayStyle={{ fontSize: '12px' }}
                    onVisibleChange={this.onChange}
                    visible={this.state.visible}

                >
                    <Dropdown overlay={this.getOverlayData()} trigger={['click']}>
                        <Icon onClick={this.onHide} type="history" style={{ fontSize: 18, color: '#CCCCCC' }} />
                    </Dropdown>
                </Tooltip>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/components/RecentlyVisited/UI.Components.tsx